document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.cc-mango-product-grid');
  if (!section) return;

  function bindForm(form) {
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const button = form.querySelector('.mango-card__atc');
      const originalText = button.textContent;

      button.textContent = 'Adding...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          button.textContent = 'Added!';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);

          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          document.dispatchEvent(new CustomEvent('on:cart:updated'));
          fetch('/cart.js')
            .then((res) => (res.ok ? res.json() : null))
            .then((cartData) => {
              if (!cartData) return;
              if (typeof window.ccDispatchCartChange === 'function') {
                window.ccDispatchCartChange({
                  cart: cartData,
                  cartUpdated: true,
                  source: 'mango-product-grid',
                });
              }
              const bubble = document.getElementById('cart-icon-bubble');
              if (!bubble) return;
              const countEl = bubble.querySelector('.header__cart-count-number');
              const countText = bubble.querySelector('.visually-hidden');
              if (countEl) countEl.textContent = cartData.item_count;
              if (countText) {
                countText.textContent = `${cartData.item_count} ${cartData.item_count === 1 ? 'item' : 'items'}`;
              }
              const cartCountContainer = bubble.querySelector('.header__cart-count');
              if (cartCountContainer) {
                cartCountContainer.style.display = cartData.item_count > 0 ? '' : 'none';
              }
            })
            .catch(() => {});
        })
        .catch(() => {
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
        });
    });
  }

  section.querySelectorAll('.mango-add-form').forEach(bindForm);

  function activateOverlays() {
    section.querySelectorAll('[data-has-subs="true"]').forEach(function (card) {
      const btn = card.querySelector('.mango-card__atc');
      if (!btn || btn.classList.contains('js-mango-sub-toggle')) return;
      const overlay = card.querySelector('.mango-sub-overlay');
      if (!overlay || !overlay.querySelector('.mango-sub-btn--subscribe')) return;
      const btnText = btn.textContent.trim().toLowerCase();
      if (btnText !== 'add to cart' && btnText !== 'preorder') return;
      btn.type = 'button';
      btn.classList.add('js-mango-sub-toggle');
    });
  }

  setTimeout(activateOverlays, 600);

  function closeAllOverlays() {
    section.querySelectorAll('.mango-sub-overlay').forEach((o) => o.classList.remove('is-open'));
    section.querySelectorAll('.mango-product-card').forEach((c) => c.classList.remove('sub-overlay-open'));
  }

  section.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;

    if (e.target.closest('.js-mango-sub-toggle')) {
      const card = e.target.closest('.mango-product-card');
      const overlay = card.querySelector('.mango-sub-overlay');
      const isOpen = overlay.classList.contains('is-open');
      closeAllOverlays();
      if (!isOpen) {
        overlay.classList.add('is-open');
        card.classList.add('sub-overlay-open');
      }
      return;
    }

    const subBtn = e.target.closest('.mango-sub-btn--subscribe, .mango-sub-btn--otp');
    if (!subBtn) return;

    const overlay = subBtn.closest('.mango-sub-overlay');
    const card = overlay.closest('.mango-product-card');
    const { variantId, isSingleVariant, productUrl } = card.dataset;
    const sellingPlan = subBtn.dataset.sellingPlan;

    if (isSingleVariant !== 'true') {
      location.href = subBtn.classList.contains('mango-sub-btn--subscribe')
        ? productUrl + '?selling_plan=' + sellingPlan
        : productUrl;
      return;
    }

    const body = { id: variantId, quantity: 1 };
    if (subBtn.classList.contains('mango-sub-btn--subscribe')) body.selling_plan = sellingPlan;

    subBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(() => {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      closeAllOverlays();
      subBtn.disabled = false;
    });
  });

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    if (!e.target.closest('.mango-product-card')) closeAllOverlays();
  });

  // ---------------------------------------------------------------------------
  // Live stock reconcile (event-driven, no polling).
  // The grid HTML is often served from Shopify's full-page cache, so stock can
  // be stale. On return-to-page / cart change we re-fetch this section via the
  // Section Rendering API (which re-runs the card Liquid: stock count, Sold Out,
  // badges) and surgically update each card — no manual refresh needed.
  // ---------------------------------------------------------------------------
  const sectionEl = section.querySelector('[data-section-id]');
  const sectionId = sectionEl ? sectionEl.dataset.sectionId : null;

  // Match a card across renders by its product URL path (no markup changes needed).
  function cardKey(card) {
    const a = card.querySelector('.mango-card__title a[href], a[href]');
    if (!a) return null;
    const href = a.getAttribute('href');
    try {
      return new URL(href, location.origin).pathname;
    } catch (err) {
      return href;
    }
  }

  // Replace / insert / remove an optional node so the old card matches the new.
  function syncOptional(oldCard, newCard, selector, containerSel) {
    const oldEl = oldCard.querySelector(selector);
    const newEl = newCard.querySelector(selector);
    if (newEl) {
      if (oldEl) {
        if (oldEl.outerHTML !== newEl.outerHTML) oldEl.replaceWith(newEl.cloneNode(true));
      } else {
        const container = oldCard.querySelector(containerSel);
        if (container) container.appendChild(newEl.cloneNode(true));
      }
    } else if (oldEl) {
      oldEl.remove();
    }
  }

  // The add-to-cart control: a form, a "Choose Options" link, or a Sold Out button.
  const ATC_SEL =
    '.mango-card__info > form.mango-add-form, .mango-card__info > a.mango-card__atc, .mango-card__info > button.mango-card__atc';

  function syncCard(oldCard, newCard) {
    // 1. "Only X left" inventory line
    const oldStock = oldCard.querySelector('.mango-card__stock');
    const newStock = newCard.querySelector('.mango-card__stock');
    if (newStock) {
      if (oldStock) {
        if (oldStock.outerHTML !== newStock.outerHTML) oldStock.replaceWith(newStock.cloneNode(true));
      } else {
        const anchor = oldCard.querySelector('.mango-card__price-row');
        if (anchor) anchor.parentNode.insertBefore(newStock.cloneNode(true), anchor);
      }
    } else if (oldStock) {
      oldStock.remove();
    }

    // 2. Media badges: top-left Sold Out label + sale badge
    syncOptional(oldCard, newCard, '.product-label-container', '.mango-card__media');
    syncOptional(oldCard, newCard, '.mango-card__sale-badge', '.mango-card__media');

    // 3. Add to Cart <-> Sold Out button
    const oldAtc = oldCard.querySelector(ATC_SEL);
    const newAtc = newCard.querySelector(ATC_SEL);
    if (newAtc) {
      if (!oldAtc) {
        const info = oldCard.querySelector('.mango-card__info');
        if (info) info.appendChild(newAtc.cloneNode(true));
      } else if (oldAtc.outerHTML !== newAtc.outerHTML) {
        const fresh = newAtc.cloneNode(true);
        oldAtc.replaceWith(fresh);
        if (fresh.matches('form.mango-add-form')) bindForm(fresh);
      }
    }
  }

  let liveBusy = false;

  function fetchLiveStock() {
    if (liveBusy || document.hidden || !sectionId) return;
    liveBusy = true;
    fetch(location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => (r.ok ? r.text() : null))
      .then((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const current = {};
        section.querySelectorAll('.mango-product-card').forEach((c) => {
          const k = cardKey(c);
          if (k) current[k] = c;
        });
        doc.querySelectorAll('.mango-product-card').forEach((nc) => {
          const k = cardKey(nc);
          if (!k) return;
          const oc = current[k];
          // Don't clobber a card whose subscription overlay is open.
          if (oc && !oc.classList.contains('sub-overlay-open')) syncCard(oc, nc);
        });
        activateOverlays();
      })
      .catch(() => {})
      .finally(() => {
        liveBusy = false;
      });
  }

  // Reconcile a stale cached page shortly after load.
  setTimeout(fetchLiveStock, 1200);
  // Returning to the page (incl. back/forward cache restore).
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchLiveStock();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fetchLiveStock();
  });
  // After the shopper's own cart change / purchase.
  document.addEventListener('on:cart:change', fetchLiveStock);
  document.addEventListener('on:cart:updated', fetchLiveStock);
});
